import type { StyleRule } from '@archipro-design/aria';
import { swipeableEdgeSlotClassNames } from '@archipro-design/aria';
import {
    drawerSlotClassNames,
    swipeableEdgeClassName,
} from '@archipro-design/aria';
import { flexClassName } from '@archipro-design/aria';
import { containerClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { topNavigationSlotClassNames } from '@archipro-design/aria';
import { topNavigationClassName } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    popupContentSlotClassNames,
    providerClassName,
} from '@fluentui/react-northstar';
import {
    LEFT_SIDE_WIDTH,
    TOP_NAV_HEIGHT,
    MOBILE_FULL_WIDTH,
} from '~/modules/design-board/config';

export const Page: StyleRule = ({ theme }) => ({
    width: '100%',
    height: '100%',
    color: theme.siteVariables.colorScheme.default?.foreground,
});

export * from '../left-side-nav/LeftSideNav.style';

export const RightSideContent: StyleRule = ({ theme }) => ({
    flexGrow: 1,
    width: `calc(100% - ${pxToRem(LEFT_SIDE_WIDTH)})`,
    backgroundColor: theme.siteVariables.colors.white['FFF'],
});

export const TopNavContent: StyleRule = ({ theme }) => ({
    [`& .${topNavigationClassName}`]: {
        width: pxToRem(MOBILE_FULL_WIDTH),
        background: theme.siteVariables.colors.white['FFF'],
    },

    [theme.screen.laptop]: {
        width: '100%',
        height: pxToRem(TOP_NAV_HEIGHT),
        textAlign: 'right',

        [`& .${topNavigationClassName}`]: {
            width: '100%',
            height: '100%',
            paddingRight: pxToRem(50),
            marginTop: pxToRem(-15),

            [`& .${topNavigationSlotClassNames.right}`]: {
                [`& .${buttonClassName}:not(:last-child)`]: {
                    marginTop: 0,
                    paddingRight: 0,
                },
            },

            [`& .${containerClassName}`]: {
                [`& .${topNavigationSlotClassNames.secondaryNavContainer}`]: {
                    display: 'none',
                },
                [`& .${topNavigationSlotClassNames.megaMenu}`]: {
                    display: 'none',
                },
            },
        },

        [`& .${providerClassName} > .${flexClassName}`]: {
            height: pxToRem(146),
        },
    },
});

export const MainContent: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 0, 50, 0]),
    [theme.screen.tablet]: {
        width: '100%',
        padding: 0,
    },
});

export const MainContentWrapper: StyleRule = () => ({
    padding: 0,
});

export const Content: StyleRule = () => ({
    flexGrow: 1,
});

export const DrawerTopWrapper: StyleRule = ({ theme, isSwipeableEdge }) => ({
    [`& .${popupContentSlotClassNames.content} .${flexClassName}.${drawerSlotClassNames.content}`]:
        {
            height: 'auto',
            justifyContent: 'flex-end',
            background: isSwipeableEdge
                ? 'transparent'
                : theme.siteVariables.colors.white['FFF'],
        },

    [`& .${swipeableEdgeClassName}`]: {
        background: '#262626', // not in aria
        borderRadius: pxArrayToRem([12, 12, 0, 0]),
        [`& .${swipeableEdgeSlotClassNames.puller}`]: {
            padding: pxArrayToRem([12, 0, 25, 0]),
        },
    },
});
